export default "<div class=\"p-\">\n<p>Print Ticket</p>\n\n</div>\n\n<button type=\"button\" class=\"btn btn-success\">Success</button>\n"